import * as React from "react";
import type { FC } from "react";
import { Gapped, Input } from "react-ui";

import { Caption, Row } from "../../FiasFnsManualEditor.styles";
import { Control } from "../controlsPaths";
import { AddressTypeField } from "../AddressTypeField";
import { AddressLevel } from "../../../../FiasInput/Types/FiasTypes";
import { getTypeSuggests } from "../AddressRow";

interface ApartmentProps {
    fullSizeAbbreviation: boolean;
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const addressLevel = AddressLevel.Room;
const controlType = Control.ApartmentType;
const controlNumber = Control.ApartmentNumber;

export const Apartment: FC<ApartmentProps> = props => (
    <Row>
        <Caption>Номер помещения / квартиры / машино-места</Caption>
        <Gapped>
            <AddressTypeField
                width={80}
                maxLength={50}
                placeholder={"Тип"}
                data-tid={"ApartmentType"}
                fullSize={props.fullSizeAbbreviation}
                controlType={controlType}
                value={props.getValue(controlType)}
                onChange={props.onChange(controlType)}
                getSuggests={getTypeSuggests(addressLevel)}
            />
            <Input
                width={260}
                maxLength={260}
                placeholder={"Номер"}
                data-tid={"ApartmentNum"}
                value={props.getValue(controlNumber)}
                onValueChange={props.onChange(controlNumber)}
            />
        </Gapped>
    </Row>
);
